import { init } from "../javascripts/color-scheme";

init();
